export default function modalInit() {
    const openers = document.querySelectorAll('[data-modal]');

    if (!openers || openers.length === 0) {
        return;
    }

    openers.forEach((opener) => {
        opener.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            const target = opener.getAttribute('data-modal');
            const modal = document.querySelector(target);

            if (!modal) {
                return;
            }

            // Do not continue if clicking inside modal and is not inside [data-modal-close]
            if (e.target !== opener && modal.contains(e.target) && !e.target.closest('[data-modal-close]')) {
                return;
            }

            const isOpened = modal.getAttribute('aria-hidden') === 'false';

            modal.setAttribute('aria-hidden', isOpened ? 'true' : 'false');
        });
    });
}
